import { render, staticRenderFns } from "./KeuanganPusat.vue?vue&type=template&id=05a0bb3e"
import script from "./KeuanganPusat.vue?vue&type=script&lang=js"
export * from "./KeuanganPusat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports